function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var ReplacementsTemplate = require('./replacements.template');
var SaitoOverlay = require('./../../../../../lib/saito/ui/saito-overlay/saito-overlay');
var ReplacementsOverlay = /*#__PURE__*/function () {
  function ReplacementsOverlay(app, mod) {
    _classCallCheck(this, ReplacementsOverlay);
    this.app = app;
    this.mod = mod;
    this.visible = false;
    this.selectedAction = '';
    // Standard Saito closebox; keep host alive across re-renders after each spend.
    // closebox=true, removeOnClose=false, clickToClose=false
    this.overlay = new SaitoOverlay(app, mod, true, false, false);
  }
  return _createClass(ReplacementsOverlay, [{
    key: "onOverlayClose",
    value: function onOverlayClose() {
      this.visible = false;
      this.selectedAction = '';
    }
  }, {
    key: "hide",
    value: function hide() {
      this.mod.game.status = 'submitting...';
      this.mod.hud.updateStatus(this.mod.game.status);
      this.mod.hud.updateMenu([]);
      this.mod.hud.updateCards([]);
      this.visible = false;
      this.selectedAction = '';
      this.overlay.callback_on_close = null;
      this.overlay.hide();
    }
  }, {
    key: "softClose",
    value: function softClose() {
      this.onOverlayClose();
      this.overlay.hide();
    }
  }, {
    key: "pullHudOverOverlay",
    value: function pullHudOverOverlay() {
      var overlay_zindex = parseInt(this.overlay.zIndex);
      var hud = document.getElementById('game-hud2');
      if (hud) {
        hud.style.zIndex = overlay_zindex + 1;
      }
    }
  }, {
    key: "pushHudUnderOverlay",
    value: function pushHudUnderOverlay() {
      var overlay_zindex = parseInt(this.overlay.zIndex);
      var hud = document.getElementById('game-hud2');
      if (hud) {
        hud.style.zIndex = overlay_zindex - 2;
      }
    }
  }, {
    key: "viewingPlayerPower",
    value: function viewingPlayerPower() {
      return this.mod.returnFactionOfPlayer() || '';
    }
  }, {
    key: "rootEl",
    value: function rootEl() {
      return document.querySelector('.replacements-overlay');
    }
  }, {
    key: "syncPlayerHeader",
    value: function syncPlayerHeader() {
      var root = this.rootEl();
      var icon = document.querySelector('.replacements-overlay .rp-header-icon');
      var power = this.viewingPlayerPower();
      if (root) {
        root.classList.remove('is-central', 'is-allies');
        if (power === 'central') {
          root.classList.add('is-central');
        } else if (power) {
          root.classList.add('is-allies');
        }
        root.dataset.faction = power || '';
      }
      if (icon) {
        icon.dataset.faction = power || '';
      }
    }
  }, {
    key: "isCorpsUnit",
    value: function isCorpsUnit(unit) {
      if (!unit) {
        return false;
      }
      if (unit.key && unit.key.indexOf('army') > -1) {
        return false;
      }
      if (unit.key && unit.key.indexOf('corps') > -1) {
        return true;
      }
      if (unit.corps) {
        return true;
      }
      if (unit.army) {
        return false;
      }
      return false;
    }
  }, {
    key: "ensureHost",
    value: function ensureHost() {
      var _this = this;
      // Always refresh from template so stale nodes (e.g. old submenu-status) cannot linger.
      var onClose = function onClose() {
        return _this.onOverlayClose();
      };
      this.overlay.show(ReplacementsTemplate(), onClose);
      return this.rootEl();
    }
  }, {
    key: "renderPoints",
    value: function renderPoints() {
      var paths_self = this.mod;
      var faction = this.viewingPlayerPower();
      var pts = document.querySelector('.replacements-overlay .points');
      if (!pts) {
        return;
      }
      pts.innerHTML = '';
      for (var key in paths_self.game.state.rp[faction]) {
        if (paths_self.game.state.rp[faction][key] > 0) {
          pts.innerHTML += "\n\t\t      <div class=\"box\">\n\t\t        <div class=\"ckey\">".concat(key, "</div>\n\t\t        <div class=\"num\">").concat(paths_self.game.state.rp[faction][key], "</div>\n\t\t      </div>\n\t\t    ");
        }
      }
    }
  }, {
    key: "markSelectedAction",
    value: function markSelectedAction() {
      var _this2 = this;
      var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      this.selectedAction = id || '';
      document.querySelectorAll('.replacements-overlay .mainmenu .controls .option').forEach(function (el) {
        el.classList.toggle('is-selected', el.id === _this2.selectedAction);
      });
    }
  }, {
    key: "renderActions",
    value: function renderActions() {
      var _this3 = this;
      var paths_self = this.mod;
      var obk = document.querySelector('.replacements-overlay .mainmenu .controls');
      if (!obk) {
        return;
      }
      var html = '<ul>';
      for (var z = 0; z < paths_self.game.state.replacements.options.length; z++) {
        var opt = paths_self.game.state.replacements.options[z];
        opt = opt.replace(/<li class="option" id="([^"]+)">([^<]*)<\/li>/, function (match, id, label) {
          return "<li class=\"option\" id=\"".concat(id, "\"><span class=\"rp-action-label\">").concat(label, "</span><span class=\"rp-chevron\" aria-hidden=\"true\">&gt;</span></li>");
        });
        html += opt;
      }
      html += '</ul>';
      obk.innerHTML = html;
      document.querySelectorAll('.replacements-overlay .mainmenu .controls ul li').forEach(function (el) {
        el.onclick = function (e) {
          var id = e.currentTarget.id;
          if (id == 'finish') {
            _this3.hide();
            paths_self.endTurn();
            return 1;
          }
          _this3.markSelectedAction(id);
          _this3.showSubMenu(id);
        };
      });
    }
  }, {
    key: "render",
    value: function render() {
      var paths_self = this.mod;
      paths_self.game.state.is_movement_from_outside_near_east = true;
      this.visible = true;
      this.selectedAction = '';
      this.ensureHost();
      this.syncPlayerHeader();
      this.renderPoints();
      this.renderActions();
      var submenu = document.querySelector('.replacements-overlay .submenu');
      if (submenu) {
        submenu.classList.remove('is-open');
        var controls = submenu.querySelector('.controls');
        if (controls) {
          controls.innerHTML = '';
        }
      }
    }
  }, {
    key: "hideSubMenu",
    value: function hideSubMenu() {
      try {
        var submenu = document.querySelector('.replacements-overlay .submenu');
        if (submenu) {
          submenu.classList.remove('is-open');
        }
        this.markSelectedAction('');
      } catch (err) {}
    }
  }, {
    key: "showSubMenu",
    value: function showSubMenu() {
      var _this4 = this;
      var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'uneliminate';
      var paths_self = this.mod;
      document.querySelectorAll('.replacements-overlay .submenu-status').forEach(function (el) {
        return el.remove();
      });
      var eu = paths_self.game.state.replacements.can_uneliminate_unit_array;
      if (id == 'repair_board') {
        eu = paths_self.game.state.replacements.can_repair_unit_on_board_array;
      }
      if (id == 'repair_reserves') {
        eu = paths_self.game.state.replacements.can_repair_unit_in_reserves_array;
      }
      if (id == 'deploy') {
        var units_available = {};
        eu = paths_self.game.state.replacements.can_deploy_unit_in_reserves_array;
        for (var i = eu.length - 1; i >= 0; i--) {
          var u = paths_self.game.spaces[eu[i].key].units[eu[i].idx];
          if (!paths_self.doReplacementPointsExistForUnit(u)) {
            eu.splice(i, 1);
          } else {
            if (!units_available[eu[i].name]) {
              units_available[eu[i].name] = 1;
            } else {
              eu.splice(i, 1);
            }
          }
        }
      }
      var obk = document.querySelector('.replacements-overlay .submenu .controls');
      var html = '<ul>';
      for (var z = 0; z < eu.length; z++) {
        var entry = eu[z];
        var unit = paths_self.game.spaces[entry.key].units[entry.idx];
        var loc = paths_self.game.spaces[entry.key].name;
        var type_class = this.isCorpsUnit(unit) ? 'is-corps' : 'is-army';
        var chit = paths_self.returnUnitImage(unit);
        html += "<li class=\"option rp-unit-row ".concat(type_class, "\" id=\"").concat(z, "\" data-key=\"").concat(unit.key || '', "\">\n        <div class=\"rp-unit-chit\">").concat(chit, "</div>\n        <div class=\"rp-unit-meta\"><span class=\"rp-unit-name\">").concat(entry.ckey, " ").concat(entry.name, "</span><span class=\"rp-unit-loc\">").concat(loc, "</span></div>\n        <span class=\"rp-chevron\" aria-hidden=\"true\">&gt;</span>\n      </li>");
      }
      html += '</ul>';
      obk.innerHTML = html;
      document.querySelectorAll('.replacements-overlay .submenu .controls ul li').forEach(function (el) {
        el.onclick = function (e) {
          var z = parseInt(e.currentTarget.id);
          var unit = paths_self.game.spaces[eu[z].key].units[eu[z].idx];
          var faction = paths_self.returnFactionOfPlayer();

          //
          // recreated armies are placed as reinforcements (17.1.5 / 9.5.3.3)
          //
          var army_spacekeys = [];
          if (id == 'uneliminate' && !unit.corps) {
            var country = '';
            if (unit.ckey == 'GE') {
              country = 'germany';
            }
            if (unit.ckey == 'AH') {
              country = 'austria';
            }
            if (unit.ckey == 'BU' || unit.ckey == 'BG') {
              country = 'bulgaria';
            }
            if (unit.ckey == 'FR') {
              country = 'france';
            }
            if (unit.ckey == 'IT') {
              country = 'italy';
            }
            if (unit.ckey == 'RO') {
              country = 'romania';
            }
            if (unit.ckey == 'RU') {
              country = 'russia';
            }
            if (unit.ckey == 'SB') {
              country = 'serbia';
            }
            if (unit.ckey == 'US') {
              country = 'usa';
            }
            if (unit.ckey == 'BR' || unit.ckey == 'BEF' || unit.ckey == 'AUS' || unit.ckey == 'CND' || unit.ckey == 'PT' || unit.ckey == 'ANA' || unit.ckey == 'MEF' || unit.ckey == 'NE') {
              country = 'england';
            }
            army_spacekeys = paths_self.returnArrayOfSpacekeysForPlacingReinforcements(country);
            if (army_spacekeys.length == 0) {
              alert('Error -- no viable placement options?');
              return;
            }
          }

          //
          // deduct RP
          //
          if (unit.ckey == 'RU' && paths_self.game.state.events.bolshevik_revolution && paths_self.game.state.events.bolshevik_ru_rp_turn == paths_self.game.state.turn) {
            alert('Bolshevik Revolution: only one Russian replacement point may be spent this turn');
            return;
          }
          if (paths_self.game.state.rp[faction][unit.ckey] > 0) {
            paths_self.game.state.rp[faction][unit.ckey]--;
          } else {
            if (paths_self.game.state.rp[faction]['CP'] > 0) {
              paths_self.game.state.rp[faction]['CP']--;
            } else {
              if (paths_self.game.state.rp[faction]['AP'] > 0) {
                paths_self.game.state.rp[faction]['AP']--;
              } else {
                if (paths_self.game.state.rp[faction]['A'] > 0) {
                  paths_self.game.state.rp[faction]['A']--;
                } else {
                  alert('You do not seem to have enough RPs to treat that unit...');
                  return;
                }
              }
            }
          }
          if (unit.ckey == 'RU' && paths_self.game.state.events.bolshevik_revolution) {
            paths_self.game.state.events.bolshevik_ru_rp_turn = paths_self.game.state.turn;
          }
          if (id == 'uneliminate') {
            paths_self.game.spaces[eu[z].key].units[eu[z].idx].destroyed = 0;
            paths_self.game.spaces[eu[z].key].units[eu[z].idx].damaged = 1;
            if (unit.corps) {
              if (paths_self.returnFactionOfPlayer() == 'central') {
                paths_self.moveUnit(eu[z].key, eu[z].idx, 'crbox');
                paths_self.prependMove("NOTIFY\t".concat(paths_self.returnFactionName(faction), " uneliminates ").concat(unit.name));
                paths_self.prependMove("repair\t".concat(faction, "\t").concat(eu[z].key, "\t").concat(eu[z].idx, "\t").concat(paths_self.game.player));
                paths_self.prependMove("move\t".concat(faction, "\t").concat(eu[z].key, "\t").concat(eu[z].idx, "\tcrbox\t").concat(paths_self.game.player));
              } else {
                paths_self.moveUnit(eu[z].key, eu[z].idx, 'arbox');
                paths_self.prependMove("NOTIFY\t".concat(paths_self.returnFactionName(faction), " uneliminates ").concat(unit.name));
                paths_self.prependMove("repair\t".concat(faction, "\t").concat(eu[z].key, "\t").concat(eu[z].idx, "\t").concat(paths_self.game.player));
                paths_self.prependMove("move\t".concat(faction, "\t").concat(eu[z].key, "\t").concat(eu[z].idx, "\tarbox\t").concat(paths_self.game.player));
              }
              paths_self.displaySpace(eu[z].key);
              paths_self.displaySpace('arbox');
              paths_self.displaySpace('crbox');
              paths_self.playerSpendReplacementPoints(paths_self.returnFactionOfPlayer());
            } else {
              var place_army = function place_army(spacekey) {
                paths_self.moveUnit(eu[z].key, eu[z].idx, spacekey);
                paths_self.prependMove("NOTIFY\t".concat(paths_self.returnFactionName(faction), " uneliminates ").concat(unit.name));
                paths_self.prependMove("repair\t".concat(faction, "\t").concat(eu[z].key, "\t").concat(eu[z].idx, "\t").concat(paths_self.game.player));
                paths_self.prependMove("move\t".concat(faction, "\t").concat(eu[z].key, "\t").concat(eu[z].idx, "\t").concat(spacekey, "\t").concat(paths_self.game.player));
                paths_self.displaySpace(eu[z].key);
                paths_self.displaySpace(spacekey);
                if (army_spacekeys.length == 1) {
                  siteMessage("".concat(unit.name, " returns to ").concat(paths_self.returnSpaceName(spacekey), ", damaged"), 2500);
                }
                paths_self.playerSpendReplacementPoints(paths_self.returnFactionOfPlayer());
              };
              if (army_spacekeys.length == 1) {
                place_army(army_spacekeys[0]);
              } else {
                _this4.hideSubMenu();
                paths_self.playerSelectSpaceWithFilter("Destination for ".concat(unit.name), function (spacekey) {
                  if (army_spacekeys.includes(spacekey)) {
                    return 1;
                  }
                  return 0;
                }, place_army, null, true);
              }
            }
          }
          if (id == 'repair_reserves') {
            paths_self.game.spaces[eu[z].key].units[eu[z].idx].damaged = 0;
            paths_self.prependMove("NOTIFY\t".concat(paths_self.returnFactionName(faction), " repairs ").concat(unit.name, " (reserves)"));
            paths_self.prependMove("repair\t".concat(faction, "\t").concat(eu[z].key, "\t").concat(eu[z].idx, "\t").concat(paths_self.game.player));
            paths_self.displaySpace(eu[z].key);
            paths_self.playerSpendReplacementPoints(paths_self.returnFactionOfPlayer());
          }
          if (id == 'repair_board') {
            paths_self.game.spaces[eu[z].key].units[eu[z].idx].damaged = 0;
            paths_self.prependMove("NOTIFY\t".concat(paths_self.returnFactionName(faction), " repairs ").concat(unit.name, " (").concat(paths_self.returnSpaceNameForLog(eu[z].key), ")"));
            paths_self.prependMove("repair\t".concat(faction, "\t").concat(eu[z].key, "\t").concat(eu[z].idx, "\t").concat(paths_self.game.player));
            paths_self.displaySpace(eu[z].key);
            paths_self.playerSpendReplacementPoints(paths_self.returnFactionOfPlayer());
          }
          if (id == 'deploy') {
            _this4.hideSubMenu();
            paths_self.game.state.does_movement_start_outside_near_east = 1;
            paths_self.game.state.does_movement_start_inside_near_east = 0;
            paths_self.playerSelectSpaceWithFilter("Destination for ".concat(unit.name), function (spacekey) {
              if (paths_self.game.spaces[spacekey].control == faction) {
                if (spacekey == 'belgrade' && unit.ckey == 'SB') {
                  if (paths_self.game.spaces['nis'].control == 'central') {
                    return 0;
                  }
                }
                if (paths_self.game.spaces[spacekey].besieged == 1) {
                  return 0;
                }
                if (paths_self.game.spaces[spacekey].units.length > 0) {
                  for (var _z = 0; _z < paths_self.game.spaces[spacekey].units.length; _z++) {
                    var _u = paths_self.game.spaces[spacekey].units[_z];
                    if (faction != paths_self.returnPowerOfUnit(_u)) {
                      return 0;
                    }
                    if (_u.ckey == unit.ckey) {
                      return 1;
                    }
                  }
                }
                if (spacekey == 'salonika') {
                  if (unit.ckey == 'SB' && (paths_self.game.state.events.salonika || paths_self.game.state.events.greek_neutral_entry)) {
                    return 1;
                  }
                }
                if (unit.ckey == 'RU') {
                  if (unit.army) {
                    if (_this4.game.spaces[spacekey].country != 'russia') {
                      return 0;
                    }
                  }
                  if (_this4.game.state.has_russian_corps_deployed_into_ne == 1) {
                    return 0;
                  } else {
                    if (_this4.game.spaces['sinai'].control != 'allies') {
                      if (_this4.game.spaces[spacekey].country == 'egypt') {
                        return 0;
                      }
                      if (_this4.game.spaces[spacekey].country == 'libya') {
                        return 0;
                      }
                    }
                  }
                }
                if (unit.ckey == 'BE') {
                  if (spacekey == 'brussels') {
                    return 1;
                  }
                  if (spacekey == 'ostend') {
                    return 1;
                  }
                  if (spacekey == 'antwerp') {
                    if (paths_self.checkSupplyStatus(unit.ckey.toLowerCase(), spacekey) == 1) {
                      return 1;
                    }
                  }
                  if (spacekey == 'calais') {
                    if (paths_self.game.spaces['brussels'].control == 'central' && paths_self.game.spaces['ostend'].control == 'central' && (paths_self.game.spaces['antwerp'].control == 'central' || !paths_self.checkSupplyStatus(unit.ckey.toLowerCase(), 'antwerp'))) {
                      return 1;
                    }
                  }
                }
                if (paths_self.checkSupplyStatus(unit.ckey.toLowerCase(), spacekey) == 1) {
                  if (paths_self.game.spaces[spacekey].units.length < 3) {
                    if (paths_self.isSpaceOnNearEastMap(spacekey)) {
                      if (!paths_self.canPlayerDeployUnitIntoNearEast(faction, unit)) {
                        return 1;
                      }
                      return 0;
                    }
                    return 1;
                  }
                }
              }
              return 0;
            }, function (spacekey) {
              if (spacekey === 'mainmenu') {
                _this4.render();
                return 1;
              }
              if (paths_self.isSpaceOnNearEastMap(spacekey)) {
                paths_self.game.state.does_movement_end_outside_near_east = 0;
                paths_self.game.state.does_movement_end_inside_near_east = 1;
                paths_self.trackDeploymentIntoNearEast(faction, unit);
              } else {
                paths_self.game.state.does_movement_end_outside_near_east = 1;
                paths_self.game.state.does_movement_end_inside_near_east = 0;
                paths_self.trackDeploymentIntoNearEast(faction, unit);
              }
              paths_self.game.status = 'moving...';
              paths_self.hud.updateStatus(paths_self.game.status);
              paths_self.hud.updateMenu([]);
              paths_self.hud.updateCards([]);
              paths_self.moveUnit(eu[z].key, eu[z].idx, spacekey);
              paths_self.prependMove("NOTIFY\t".concat(paths_self.returnFactionName(faction), " deploys ").concat(unit.name, " to ").concat(paths_self.returnSpaceNameForLog(eu[z].key)));
              paths_self.prependMove("move\t".concat(faction, "\t").concat(eu[z].key, "\t").concat(eu[z].idx, "\t").concat(spacekey, "\t").concat(paths_self.game.player));
              paths_self.displaySpace(eu[z].key);
              paths_self.displaySpace(spacekey);
              paths_self.playerSpendReplacementPoints(paths_self.returnFactionOfPlayer());
            }, null, true, [{
              key: 'mainmenu',
              value: 'back to menu'
            }]);
          }
        };
      });
      try {
        var submenu = document.querySelector('.replacements-overlay .submenu');
        if (submenu) {
          submenu.classList.add('is-open');
        }
        this.markSelectedAction(id);
      } catch (err) {}
    }
  }]);
}();
module.exports = ReplacementsOverlay;